import Vue from 'vue'
import router from './router'
import App from './App.vue'
import filter from './filter'
import api from './api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.prototype.confirmBox = async (msg,cb) =>{//确定提示框
    try{
        await Vue.prototype.$confirm(msg,'提示',{confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'});
        cb();
    }catch (e){
        console.log(e);
    }
}

Vue.prototype.beforeUpload = file => {
    const isJPG = file.type === 'image/jpeg';
    // const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG) {
        Vue.prototype.$notify({ message: `上传头像图片只能是 JPG 格式!`, type: 'error'});
    }
    // if (!isLt2M) {
    //     Vue.prototype.$notify({ message: `上传头像图片大小不能超过 2MB!`, type: 'error'});
    // }
    return isJPG;
}

Vue.prototype.api = api;

Vue.prototype.uploadUrl = window.config.uploadUrl;

Vue.prototype.getUploadFileUrl = window.config.getUploadFileUrl;

Array.prototype.getIndexById = function(id){//从数组中删除某值By Id
    for(let i=0; i<this.length; i++) {
        if(this[i].id == id) {
            return i;
        }
    }
    return -1;
}

for(let p in filter){//遍历对象属性，加载所有方法到filter
    Vue.filter( p ,filter[p]);
}

let vm = new Vue({
    el: '#app',
    router,
    render: h => h(App),
})

export default vm//导出这个实例
